//@flow

import * as React from "react"
import styled from "styled-components"
import { TweenMax } from "gsap"

type Props = {
  selected: boolean,
  top: string,
  left: string,
  highlightDelay?: number,
  innerRef?: (el: HTMLElement) => any,
  onClick?: (e: Event) => any
}

const Container = styled.div`
  height: ${({ radius }) => radius * 2}px;
  width: ${({ radius }) => radius * 2}px;
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  position: absolute;
  z-index: 3;
`

const SvgContainer = styled.svg`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: ${props => props.marginLeft}px;
  margin-top: ${props => props.marginTop}px;
  pointer-events: none;
`

class Hotspot extends React.Component<Props> {
  radius: number
  highlight: ?SVGCircleElement
  animations: TweenMax[]

  constructor(props: Props) {
    super(props)
    this.radius = 8
    this.animations = []
  }

  componentDidMount() {
    const { highlightDelay } = this.props
    TweenMax.set(this.highlight, {
      opacity: 1,
      scale: 0.5,
      transformOrigin: "50% 50%"
    })
    this.animations = [
      TweenMax.to(this.highlight, 3, {
        opacity: 0,
        repeat: -1,
        scale: 1.25,
        transformOrigin: "50% 50%",
        repeatDelay: highlightDelay ? highlightDelay / 2 : 1,
        delay: highlightDelay || 0
      })
    ]
  }

  componentWillUnmount() {
    this.killAllAnimations()
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.selected !== prevProps.selected) {
      this.killAllAnimations()
      TweenMax.set(this.highlight, { opacity: 0 })
    }
  }

  killAllAnimations = () => {
    for (let animation of this.animations) {
      animation.kill()
    }
  }

  render() {
    const { top, left, selected, innerRef, onClick } = this.props
    const svgSize = this.radius * 2 * 3
    return (
      <Container
        top={top}
        left={left}
        radius={this.radius}
        innerRef={innerRef}
        onClick={onClick}
      >
        <SvgContainer
          width={`${svgSize}px`}
          height={`${svgSize}px`}
          marginTop={-svgSize / 2}
          marginLeft={-svgSize / 2}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <circle
            style={{
              fill: selected ? "#25beae" : "#fff"
            }}
            cx={svgSize / 2}
            cy={svgSize / 2}
            r={this.radius}
          />
          <circle
            ref={el => (this.highlight = el)}
            style={{
              fill: "#fff"
            }}
            cx={svgSize / 2}
            cy={svgSize / 2}
            r={this.radius * 1.75}
          />
        </SvgContainer>
      </Container>
    )
  }
}

export default Hotspot



// WEBPACK FOOTER //
// ./src/Kiosk/BodyView/Hotspot.js